<template>
  <nav class="v-tab-nav">
    <slot></slot>
  </nav>
</template>

<script>
export default {
  name: "v-tab-nav",
  props: {
    index: { type: Number, default: 0 }
  },
  created() {
    this.$on("active", (activeNavItem, isOpen) => {
      [].forEach.call(this.$children, (navItem, index) => {
        if (activeNavItem !== navItem) {
          navItem.$emit("active", false);
        } else {
          this.$emit("index", index);
        }
      });
    });
  },
  mounted() {
    this.$children[this.index].$emit("active", true);
  }
};
</script>

<style lang="scss">
@import "../../design/variables.scss";

.v-tab-nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 0 10px;

  .v-nav-item {
    display: flex;
    align-self: stretch;
    align-items: stretch;
    .v-nav-item-title {
      padding: 12.5px 0;
      font-size: 0.9375rem;
    }
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background: #ebebeb;
  }
}
</style>
